import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import Toolbar from "../../components/Toolbar";
import AxiosAPI from "../../scripts/AxiosAPI";
import { Badge, Flex, Modal, notification, Popconfirm, Tabs } from "antd";

import { SearchOutlined } from "@ant-design/icons";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import DisableButtonEventType from "../../components/DisableButtonEventType";
import ExportCSVButton from "../../components/ExportCSVButton";

interface DataType {
  key: string;
  name: string;
  points: any;
  enabled: any;
  action: any;
}

type DataIndex = keyof DataType;

function RewardsEventTypesComponent() {
  const [itemLabel, setItemLabel] = useState("");

  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    name: "",
    points: 0,
  });

  const [items, setItems] = useState([]);

  const [modalOpenCreate, setModalOpenCreate] = useState(false);

  const [modalOpenEdit, setModalOpenEdit] = useState(false);

  const [id, setId] = useState(0);

  const [name, setName] = useState("");

  const [points, setPoints] = useState(0);

  const [description, setDescription] = useState("");

  const [slug, setSlug] = useState("");

  const [enabled, setEnabled] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const addItem: any = () => {
    setModalOpenCreate(false);

    console.log("addItem", { id: 0, name, points });

    AxiosAPI.setRewardsLevel(name, points, 0)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `${name} has been added successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const openNewItemModal: any = () => {
    setId(0);

    setName("");

    setPoints(0);

    setModalOpenCreate(true);
  };

  const editItem: any = () => {

    setModalOpenEdit(false);

    setModalOpenCreate(false);

    console.log("editItem", {id, name, points, description, slug, enabled});

    const payload:any = {id, name, points, description, slug, enabled}

    AxiosAPI.setRewardsEventType(id, payload)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `${name} has been updated successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const editThisItem: any = (item: any) => {
    setSelectedItem(item);

    console.log("editThisItem::", item);

    setId(item.id);

    setName(item.name);

    setDescription(item.description);

    setSlug(item.slug);

    setPoints(item.points);

    setEnabled(item.enabled);

    setModalOpenEdit(true);

    console.log({id, name, points, description, slug});
  };

  useEffect(() => {
    setItemLabel("Rewards Event Types");

    AxiosAPI.getRewardsEventTypes()
      .then((res: any) => {
        const _data = res.data;

        setItems(_data);
      })
      .catch((error: any) => {});
  }, []);

  useEffect(() => {
    setModalOpenCreate(false);
  }, [selectedItem]);

  const [eventTypesData, setEventTypesData] = useState([]);
  const [eventTypesDataDisabled, setEventTypesDataDisabled] = useState([]);
  const [exportData, setExportData] = useState([]);

  const refreshListView: any = () => {
    AxiosAPI.getRewardsEventTypes()
      .then((res: any) => {
        let _eventTypes: any = res.data;
        setExportData(_eventTypes);
        const activeItems: any = _eventTypes.map(
          (item: any, itemIndex: number) => {
            if (item.enabled) {
              return {
                key: itemIndex,
                name: (
                  <>
                    <strong>{item.name}</strong>
                    <br />
                    {item.description}
                    <br />
                    <code>{item.slug}</code>
                  </>
                ),
                points: item.points,
                enabled: item.enabled,
                action: (
                  <Flex gap={20}>
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => editThisItem(item)}
                      className="m-r-5"
                    >
                      Edit Event Type
                    </Button>
                    <DisableButtonEventType
                      onDeleteItem={refreshListView}
                      item={item}
                      disable={true}
                    />
                  </Flex>
                ),
              };
            }
          }
        );
        setEventTypesData(activeItems.filter((value: any) => value !== undefined));

        console.log("setEventTypesData", activeItems.filter((value: any)  => value !== undefined));
        
        const inactiveItems: any = _eventTypes.map(
          (item: any, itemIndex: number) => {
            if (!item.enabled) {
              return {
                key: itemIndex,
                name: (
                  <>
                    <strong>{item.name}</strong>
                    <br />
                    {item.description}
                    <br />
                    <code>{item.slug}</code>
                  </>
                ),
                enabled: item.enabled,
                points: item.points,
                action: (
                  <Flex gap={20}>
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => editThisItem(item)}
                      className="m-r-5"
                    >
                      Edit Event Type
                    </Button>
                    <DisableButtonEventType
                      onDeleteItem={refreshListView}
                      item={item}
                    />
                  </Flex>
                ),
              };
            }
          }
        );
        setEventTypesDataDisabled(inactiveItems.filter((value: any)  => value !== undefined));

        console.log("setEventTypesDataDisabled", inactiveItems.filter((value: any)  => value !== undefined));

      })
      .catch((error: any) => {
        // Handle error
      });
  };

  useMemo(() => {
    refreshListView();
  }, []);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Event Type Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Event Type Points",
      dataIndex: "points",
      key: "points",
      width: "20%",
      ...getColumnSearchProps("points"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "20%",
    },
  ];

  const operations = <Button onClick={refreshListView}>Refresh Data</Button>;

  const [tabItems, setTabItems] = useState<any>([]);

  useEffect(() => {
    setTabItems([
      {
        label: (
          <>
            Active Event Types{" "}
            <Badge count={eventTypesData.length} showZero color="#1c84ff" />
          </>
        ),
        key: 1,
        children: <Table columns={columns} dataSource={eventTypesData} />,
      },
      {
        label: (
          <>
            Disabled Event Types{" "}
            <Badge count={eventTypesDataDisabled.length} showZero color="#1c84ff" />
          </>
        ),
        key: 2,
        children: <Table columns={columns} dataSource={eventTypesDataDisabled} />,
      },
    ]);
  }, [eventTypesData]);

  return (
    <>
      {contextHolder}
      {/*begin::Toolbar*/}
      <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">
        <Toolbar title={itemLabel}>
          {/*begin::Toolbar*/}
          <div
            className="d-flex justify-content-end"
            data-kt-user-table-toolbar="base"
            data-select2-id="select2-data-131-i76u"
          >
            {/*begin::Export*/}
            <ExportCSVButton csvData={[...exportData]} />
            {/*end::Export*/}
          </div>
          {/*end::Toolbar*/}
        </Toolbar>
      </div>
      {/*end::Toolbar*/}
      {/*begin::Content*/}
      <div
        id="kt_app_content"
        className="app-content  flex-column-fluid "
        data-select2-id="select2-data-kt_app_content"
      >
        {/*begin::Content container*/}
        <div
          id="kt_app_content_container"
          className="app-container  container-xxl "
          data-select2-id="select2-data-kt_app_content_container"
        >
          {/*begin::Card*/}
          <div className="card" data-select2-id="select2-data-134-i7jk">
            {/*begin::Card body*/}
            <div className="card-body py-4">
              {/*begin::Table*/}
              <div
                id="kt_table_users_wrapper"
                className="dt-container dt-bootstrap5 dt-empty-footer pt-5"
              >
                <Tabs tabBarExtraContent={operations} items={tabItems} />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Content container*/}
      </div>
      {/*end::Content*/}

      <Modal
        title={`Add New Item`}
        centered
        open={modalOpenCreate}
        onOk={() => {
          addItem();
          setModalOpenCreate(false);
        }}
        onCancel={() => setModalOpenCreate(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">Level</label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The level label"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Level Points
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The level points"
              value={points}
              onChange={(e) => setPoints(Number(e.target.value))}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
        </div>
        {/*end::Scroll*/}
      </Modal>

      <Modal
        title={`Edit ${name}`}
        centered
        open={modalOpenEdit}
        onOk={() => {
          editItem();
          setModalOpenEdit(false);
        }}
        onCancel={() => setModalOpenEdit(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Event Type Title
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The event type title"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Event Type Points
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The event type points"
              value={points}
              onChange={(e) => setPoints(Number(e.target.value))}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Event Type Description
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <textarea
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The event type description"
              onChange={(e) => setDescription(e.target.value)}
            >
              {description}
            </textarea>
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
            <br />
            <br />
            <code>{slug}</code>
            <input
              type="text"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The event type points"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
            />
          </div>
          {/*end::Input group*/}
        </div>
        {/*end::Scroll*/}
      </Modal>
    </>
  );
}

export default RewardsEventTypesComponent;
